export const PostcodeKey = "postcode"
export const PaymentDayKey = "paymentDay"
export const TariffName = "tariffName"

export const SmartMeterEvTariffEligibilityErrors = {
  NO_SMART_METER: "NO_SMART_METER",
  ECO_7_METER: "ECO_7_METER",
  NOT_DCC_ACTIVE: "NOT_DCC_ACTIVE",
  EES_API_ERROR: "EES_API_ERROR",
  UNKNOWN: "UNKNOWN"
}
